import fabricRose from '../assets/backgrounds/fabric-slide-rose.png';
import fabricLilac from '../assets/backgrounds/fabric-slide-lilac.png';
import fabricMint from '../assets/backgrounds/fabric-slide-mint.png';
import fabricGold from '../assets/backgrounds/fabric-slide-gold.png';

/** Default fabric carousel slides when admin has not uploaded banners */
export const FABRIC_SLIDES = [
  {
    id: 'fabric-rose',
    image: fabricRose,
    title: 'Silk & Story',
    subtitle: 'Draped in rose-gold weaves for every celebration',
    ctaText: 'Shop Fabrics',
    ctaLink: '/products',
  },
  {
    id: 'fabric-lilac',
    image: fabricLilac,
    title: 'Brocade Dreams',
    subtitle: 'Lilac zari threads woven into timeless silhouettes',
    ctaText: 'Explore',
    ctaLink: '/products',
  },
  {
    id: 'fabric-mint',
    image: fabricMint,
    title: 'Organza Light',
    subtitle: 'Sheer layers in mint and peach for festive mornings',
    ctaText: 'Discover',
    ctaLink: '/products',
  },
  {
    id: 'fabric-gold',
    image: fabricGold,
    title: 'Banarasi Glow',
    subtitle: 'Amber silk folds that catch every ray of light',
    ctaText: 'Shop Now',
    ctaLink: '/products',
  },
];

export default FABRIC_SLIDES;
